import React, { useState, useEffect, useRef } from "react";
import { motion, useAnimation, useInView } from "framer-motion";

const cities = [
    {
        name: <>100 + Destinations<br />
            covered</>,
        image:
            "https://albidayahgroups.com/Media/Travel/11245.jpg",
    },
    {
        name: <>End To End<br />
            Travel Planning</>,
        image:
            "https://albidayahgroups.com/Media/Travel/End%20To%20End%20Travel%20Planning",
    },
    {
        name: <>Personalized &<br />
            Flexible Packages</>,
        image:
            "https://albidayahgroups.com/Media/Travel/Personalized%20&%20Flexible%20Packages",
    },
];

const containerVariant = {
    hidden: {},
    visible: {
        transition: {
            staggerChildren: 0.3,
        },
    },
};

const cardVariant = {
    hidden: { opacity: 1, clipPath: "inset(0 100% 0 0)" },
    visible: {
        opacity: 1,
        clipPath: "inset(0 0% 0 0)",
        transition: {
            duration: 1.2,
            ease: "easeInOut",
        },
    },
};

const Slider = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });
    const controls = useAnimation();

    useEffect(() => {
        if (isInView) {
            controls.start("visible");
        }
    }, [isInView, controls]);

    return (
        <div className="flex justify-center items-center">
            <motion.section
                ref={ref}
                variants={containerVariant}
                initial="hidden"
                animate={controls}
                className="flex flex-col md:flex-row justify-center items-center w-full gap-5"
            >
                {cities.map((city, index) => (
                    <motion.div
                        key={index}
                        variants={cardVariant}
                        className={`
                            group
                            w-full 
                            ${activeIndex === index
                                ? "md:flex-[3] scale-100"
                                : "md:flex-[0.4] scale-95"
                            }
                            flex-[unset] 
                            h-[60vh] md:h-[80vh] 
                            rounded-[40px] 
                            relative overflow-hidden 
                            transition-all duration-700
                            max-sm:scale-100
                        `}
                        onClick={() => setActiveIndex(index)}
                    >
                        <img
                            src={city.image}
                            alt={city.name}
                            className={`
                                absolute inset-0 w-full h-full object-cover rounded-[40px] 
                                transition-all duration-700 max-sm:scale-100
                                ${activeIndex === index ? "scale-105" : "scale-95"}
                            `}
                        />

                        <div
                            className={`absolute bottom-0 left-0 w-full px-6 pb-12 text-white text-2xl font-extrabold font-sans bg-gradient-to-t from-black to-transparent ${activeIndex === index
                                ? "opacity-100"
                                : "opacity-0 md:opacity-0 max-sm:opacity-100"
                                } transition-all duration-500 delay-200 z-20`}
                        >
                            {city.name}
                        </div>
                    </motion.div>
                ))}
            </motion.section>
        </div>
    );
};

export default Slider;



